import { StadiumCamera } from 'app/models/stadium-camera';

export class PannellumStadiumCamera {
    id: string
    posName: string
    pitch: number;
    yaw: number;
    type: string;
    cssClass?: string;
    createTooltipFunc?: (hotSpotDiv: any, stadiumCamera: StadiumCamera) => void;
    createTooltipArgs: StadiumCamera;
}



// WEBPACK FOOTER //
// ./src/app/models/pannellum-stadium-camera.ts